
const AccountTypeSelector = ({ email, onClose }) => {
  // Account type selector component
  // This component allows users to select their account type during signup/login
  // For now, return null to prevent errors - can be implemented later
  return null;
};

export default AccountTypeSelector;


